import React, {useState} from 'react';
import colours from 'styles/colours';

const triggerStyles = (open) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    background: open ? colours.background.bannerActive : 'transparent',
    border: 'none',
    color: colours.font.contrast,
    cursor: 'pointer',
    padding: '6px 12px',
    borderRadius: 6,
    fontSize: 13,
    fontFamily: 'inherit',
    letterSpacing: '0.01em',
    transition: 'background 0.15s',
    whiteSpace: 'nowrap',
});

const usernameStyles = {
    maxWidth: 220,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

const whiteIcon = {filter: 'brightness(0) invert(1)'};

const personIconStyles = (filled) => ({
    fontFamily: '"Material Symbols Outlined Uniportal"',
    fontSize: 22,
    lineHeight: 1,
    color: 'inherit',
    fontVariationSettings: `"FILL" ${filled ? 1 : 0}`,
    transition: 'font-variation-settings 0.2s',
    userSelect: 'none',
});

const chevronIconStyles = (open) => ({
    ...whiteIcon,
    width: 10,
    height: 10,
    transition: 'transform 0.2s',
    transform: open ? 'rotate(-90deg)' : 'rotate(90deg)',
});

export default function Trigger({open, username, onToggle}) {
    const [hovered, setHovered] = useState(false);
    return (
        <button
            style={{
                ...triggerStyles(open),
                background: open
                    ? colours.background.bannerActive
                    : (hovered ? colours.background.bannerHover : 'transparent'),
            }}
            onClick={onToggle}
            aria-haspopup="true"
            aria-expanded={open}
            aria-label="Account menu"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <span
                className="material-symbols-outlined"
                aria-hidden="true"
                style={personIconStyles(hovered || open)}
            >
                account_circle
            </span>
            <span style={usernameStyles}>{username}</span>
            <img src="/images/icons/chevron-right.svg" alt="" aria-hidden="true" style={chevronIconStyles(open)}/>
        </button>
    );
}
